<template>
  <slot name="time"></slot>
  <div class="chat_client">
    <VMarkdownView
        :mode="mode"
        style="background: #eaeefd"
        :content="item.question"
    >
    </VMarkdownView>
  </div>
  <div class="chat_ai">
    <div style="padding: 10px;background:#EFEFEF;border-radius: 4px"
         v-if="item.content==='' && item.associateContent===''">
      <AILoading :isEmailAI="isEmailAI" :isSelectModel="isSelectModel" v-if="!isSelectModel||isEmailAI"></AILoading>
      <AIDeepLoading v-else></AIDeepLoading>
    </div>
    <div v-else>
      <VMarkdownView
          class="associateContent"
          :mode="mode"
          v-if="item.associateContent!==''"
          :content="'>'+item.associateContent"
      >
      </VMarkdownView>
      <VMarkdownView
          class="content"
          v-if="item.content!==''"
          :mode="mode"
          :content="item.content"
      >
      </VMarkdownView>
      <transition name="fade">
        <div v-if="item.isCompletedAIChat"
             class="tools-bar">
          <div style="display: flex;align-items: center">
            <el-button @mousedown.stop
                       @click="isEmailAI?handleClickInsertContentToTinyMCE(item&&item.content?item.content:' '):handleClickCopy(item&&item.content?item.content:' ')"
                       type="info" class="btn-tool" round>
              {{ isEmailAI ? $t('email.ai.insert') : $t('ai.com.txt') }}
            </el-button>
            <el-icon @click.stop="handleClickNoClose(item&&item.content?item.content:' ')"
                     style="margin-left: 10px;color: #3e3e3e">
              <CopyDocument/>
            </el-icon>
            <el-icon @click="handleClickRefresh(item)"
                     style="margin-left: 10px;color: #3e3e3e">
              <Refresh/>
            </el-icon>
            <!--            <span @click="handleClickReStart(item)">继续生成</span>-->
          </div>
          <div>
            <!--            {{ item.parentAreaCount }}-->
            <PageCom v-if="item.childCount>=1" :item="item" :type="isEmailAI?2:1"
                     :current-page="getCurrentPage(item)" @update-page="updatePage"></PageCom>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";
import {VMarkdownView} from 'vue3-markdown'
import 'vue3-markdown/dist/style.css'
import AILoading from "@/components/AI/AILoading.vue";
import PageCom from "@/components/AI/Page.vue"
import {ElMessage} from "element-plus";
import useClipboard from "vue-clipboard3";
import {useStore} from "vuex";
import AIDeepLoading from "@/components/AI/AIDeepLoading.vue";
import {i18n} from "@/lang";
import MarkdownIt from "markdown-it";

const {toClipboard} = useClipboard();
const emit = defineEmits(["refresh"])
const mode = ref('light')
const {item, chatContentArray, isLastAI, content, isSelectModel, isEmailAI} = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  chatContentArray: {
    type: Object,
    default: []
  },
  isLastAI: {
    type: Boolean,
    default: false
  },
  content: {
    type: String,
    default: "",
  },
  isSelectModel: {
    type: Boolean,
    default: false
  },
  isEmailAI: {
    type: Boolean,
    default: false,
  }
})
const handleClickRefresh = (item) => {
  emit("refresh", item)
}

const handleClickReStart = (item) => {
  emit("restart", item)
}

const handleClickCopy = async (val) => {
  console.log(val)
  try {
    await toClipboard(val)
    ElMessage.success(i18n.global.t('copy.successfully'))
    emit("closeCopy")
  } catch (e) {
    ElMessage.error(i18n.global.t('copy.failed'))
  }
}

const handleClickNoClose = async (val) => {
  try {
    await toClipboard(val)
    ElMessage.success(i18n.global.t('copy.successfully'))
  } catch (e) {
    ElMessage.error(i18n.global.t('copy.failed'))
  }
};

// 使用对象结构，key 为 item.id，value 为当前页码
const pageMap = ref({});
const getCurrentPage = (itemId) => {
  // 判断是否为详情页
  return (pageMap.value[itemId]) || (item.isDetail ? item.childCount + 1 : 1);
};
const updatePage = (itemId, newPage) => {
  pageMap.value[itemId] = newPage;
};


const handleClickInsertContentToTinyMCE = (content) => {
// md 转 html 配置
  const md = new MarkdownIt({
    html: true,        // 允许 HTML
    linkify: true,     // 自动识别链接
    // breaks: true       // 换行转 <br>
  })
  const html = md.render(content)
  console.log(content, html, '要插入的内容')
  // const editor = tinyEditorWrite.value?.tinyMCEEditor?.getEditor();
  // if (editor) {
  //   // editor.setContent(html)
  //   // editor.insertContent(html)
  //   editor.selection.setContent(html)
  // }
  emit("insertContentToTinyMCE", html)
}

</script>

<style lang="less" scoped>
.chat_ai {
  margin-top: 10px;
  max-width: 96%;
  width: auto;
  border-radius: 6px;
  height: auto;
  background: #EFEFEF;
  //padding: 10px 20px 10px 20px;
  font-size: 14px !important;
  margin-right: auto;
  //padding-bottom: 20px;
}

:deep(.markdown-body) {
  background: rgba(0, 0, 0, 0) !important;
  font-size: 14px !important;
}

.btn-tool {
  width: 100px;
  height: 30px;
  background: #FFFFFF;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: black;
  border: 0px transparent;
  font-size: 13px !important;
  font-weight: 400 !important;
}

.tools-bar {
  //height: 30px;
  width: 100%;
  //background: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px 10px 20px !important;
  background: #EFEFEF;
}

.chat_client {
  margin-top: 10px;
  border-radius: 6px;
  max-width: 96%;
  width: auto;
  height: auto;
  background: #E9EEFF;
  padding: 10px 20px 10px 20px;
  font-size: 14px !important;
  margin-left: auto;
}

.associateContent {
  background: white !important;
  padding: 10px 20px 10px 20px !important;
}

.content {
  border-radius: 4px !important;
  background: #EFEFEF !important;
  padding: 10px 20px 10px 20px !important;
}
</style>